import { render } from "./HomeDetails.vue?vue&type=template&id=29270c9f&scoped=true"
import script from "./HomeDetails.vue?vue&type=script&lang=js"
export * from "./HomeDetails.vue?vue&type=script&lang=js"

import "./HomeDetails.vue?vue&type=style&index=0&id=29270c9f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29270c9f"]])

export default __exports__